// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__1yrcw","bg":"styles_bg__13FQb","ft":"styles_ft__2ou2u","btn1":"styles_btn1__3b3jV","btn2":"styles_btn2__2cc2P"};